import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SuccessPopupGreen = ({
  open,
  primaryURL,
  secondaryURL,
  message,
  handleCloseSuccessPopup,
  primaryText,
  secondaryText,
  title,
  child,
}) => {
  const navigate = useNavigate();

  const handlePrimaryAction = () => {
    handleCloseSuccessPopup();
    if (primaryURL) {
      navigate(primaryURL);
    }
  };

  const handleSecondaryAction = () => {
    handleCloseSuccessPopup();
    if (secondaryURL) {
      navigate(secondaryURL);
    }
  };
  return (
    <Modal
      show={open}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-success-dialog open-sans-font"
    >
      <Modal.Body className="text-center d-flex flex-column row-gap-4">
        <h2
          className="fw-bolder m-0"
          style={{ color: "#359742", fontSize: "28px" }}
        >
          {title}
        </h2>
        <p style={{ color: "#171717" }} className="text-break m-0">
          {message}
        </p>
        {child}
        <div className="d-flex gap-3 flex-wrap-reverse">
          {secondaryText && (
            <div className="flex-grow-1 d-flex">
              <Button
                variant="dark fw-bold flex-grow-1 h-100"
                type="submit"
                onClick={handleSecondaryAction}
                style={{ paddingBlock: "10px", fontSize: "18px" }}
              >
                {secondaryText}
              </Button>
            </div>
          )}
          <Button
            variant="primary"
            className="button_custom fw-bold text-black flex-grow-1"
            onClick={handlePrimaryAction}
            style={{ fontSize: "18px" }}
          >
            {primaryText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessPopupGreen;
